import { formatDistance, isValid, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EmployeeProfileQuery_employee } from '../../../../typings/EmployeeProfileQuery'
import { Information } from '../../../../../Information'
import { NotSetValue } from '../../../NotSetValue'

interface Props {
  employee: EmployeeProfileQuery_employee
}

export const AdditionalInformation: FC<Props> = ({ employee }) => {
  const [t] = useTranslation('web_ui')

  const { preferredLanguage } = employee
  const phone = employee.mobile

  const lastSeenAt = useMemo(() => {
    if (!employee.lastSeenAt) {
      return null
    }
    const lastSeenAtParsed = parseISO(String(employee.lastSeenAt))

    return isValid(lastSeenAtParsed)
      ? formatDistance(lastSeenAtParsed, new Date(), {
          addSuffix: true
        })
      : null
  }, [employee.lastSeenAt])

  return (
    <>
      <Information.InformationField label={t('employee_profile.last_seen_at')}>
        {lastSeenAt ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField
        label={t('employee_profile.preferred_language')}
      >
        {preferredLanguage ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField label={t('employee_profile.phone')}>
        {phone ?? <NotSetValue />}
      </Information.InformationField>

      <Information.InformationField label={t('employee_profile.email')}>
        {employee.email ?? <NotSetValue />}
      </Information.InformationField>
    </>
  )
}
